export default __webpack_public_path__ + "static/media/badges-icon.ef83028b.png";